define('reviewsParameters',[], () => {
  'use strict';

  const reviewsParameters = {
    BrandId: 0,
    PageSize: 1,
    StateName: '',
    StateAbbreviation: '',
    MarketName: '',
    IsMarketSearch: false,
    ReviewSortBy: 2, // HighestToLowest
    PageNumber: 1,
    MarketId: null,
    ReviewStar: null,
    BuilderToSearch: '',
    SearchType: '',
    isReviewsPage: false
  };

  /**
   * Builds the default Ratings Search Params.
   * @returns Ratings Search Params Object.
  */
  function getReviewsDefaultParameters() {
    return reviewsParameters;
  }

  return {
    getReviewsDefaultParameters
  };
});

